// src/components/Popups/FornecedorPopup.jsx

import React, { useState } from 'react';
import { FiX, FiSave } from 'react-icons/fi';
import Swal from 'sweetalert2';
import axios from 'axios';
import { API_BASE_URL } from '../../../config';
import styles from './FornecedorPopup.module.css';

const FornecedorPopup = ({ onClose, onSaveSuccess }) => {
    const [nomeEmpresa, setNomeEmpresa] = useState('');
    const [cnpj, setCnpj] = useState('');
    const [telefone, setTelefone] = useState('');
    const [email, setEmail] = useState('');
    const [inscricaoEstadual, setInscricaoEstadual] = useState('');
    const [endereco, setEndereco] = useState('');
    const [contatoPrincipal, setContatoPrincipal] = useState('');

    const handleSave = async () => {
        if (!nomeEmpresa.trim()) {
            Swal.fire('Atenção!', 'O nome da empresa é obrigatório.', 'warning');
            return;
        }

        const fornecedorData = {
            nome_empresa: nomeEmpresa,
            cnpj, // O backend vai limpar a formatação
            telefone,
            email,
            inscricao_estadual: inscricaoEstadual,
            endereco: endereco,
            contato_principal: contatoPrincipal
        };

        try {
            const token = localStorage.getItem('token');
            const response = await axios.post(`${API_BASE_URL}/api/fornecedores`, fornecedorData, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            
            Swal.fire({
                title: 'Sucesso!',
                text: 'Fornecedor cadastrado com sucesso.',
                icon: 'success',
                timer: 1500,
                showConfirmButton: false
            });
            
            onSaveSuccess({ id: response.data.id, ...fornecedorData });
            onClose();
        } catch (error) {
            const errorMessage = error.response?.data?.error || 'Não foi possível salvar o fornecedor.';
            Swal.fire('Erro!', errorMessage, 'error');
        }
    };

    // --- CORREÇÃO ---
    // Função para aplicar a máscara de CNPJ enquanto o usuário digita.
    const handleCnpjChange = (e) => {
        let value = e.target.value;
        // 1. Remove tudo que não for número
        value = value.replace(/\D/g, '');
        // 2. Limita o tamanho para 14 dígitos
        value = value.substring(0, 14);
        // 3. Aplica a máscara de formatação (XX.XXX.XXX/XXXX-XX)
        value = value.replace(/^(\d{2})(\d)/, '$1.$2');
        value = value.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
        value = value.replace(/\.(\d{3})(\d)/, '.$1/$2');
        value = value.replace(/(\d{4})(\d)/, '$1-$2');
        setCnpj(value);
    };

    return (
        <div className={styles.popupOverlay}>
            <div className={styles.popupContent}>
                <div className={styles.popupHeader}>
                    <h2>Novo Fornecedor</h2>
                    <button onClick={onClose} className={styles.closeButton}><FiX /></button>
                </div>
                <div className={styles.popupBody}>
                    <input
                        type="text"
                        className={styles.input}
                        placeholder="Nome da Empresa *"
                        value={nomeEmpresa}
                        onChange={(e) => setNomeEmpresa(e.target.value)}
                    />
                    <input
                        type="text"
                        className={styles.input}
                        placeholder="CNPJ"
                        value={cnpj}
                        // --- CORREÇÃO ---
                        // Aplica a função de máscara no evento onChange
                        onChange={handleCnpjChange} 
                        maxLength="18" // Define um tamanho máximo para o campo (14 números + 4 caracteres de formatação)
                    />
                    <input
                        type="text"
                        className={styles.input}
                        placeholder="Inscrição Estadual"
                        value={inscricaoEstadual}
                        onChange={(e) => setInscricaoEstadual(e.target.value)}
                    />
                    <input
                        type="text"
                        className={styles.input}
                        placeholder="Endereço Completo"
                        value={endereco}
                        onChange={(e) => setEndereco(e.target.value)}
                    />
                    <input
                        type="text"
                        className={styles.input}
                        placeholder="Telefone"
                        value={telefone}
                        onChange={(e) => setTelefone(e.target.value)}
                    />
                     <input
                        type="email"
                        className={styles.input}
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <input
                        type="text"
                        className={styles.input}
                        placeholder="Nome do Contato Principal"
                        value={contatoPrincipal}
                        onChange={(e) => setContatoPrincipal(e.target.value)}
                    />
                </div>
                <div className={styles.popupFooter}>
                    <button onClick={handleSave} className={styles.saveButton}><FiSave /> Salvar</button>
                </div>
            </div>
        </div>
    );
};

export default FornecedorPopup;